/* global axios */

import ApiClient from './ApiClient';

const buildPayload = data => {
  const formData = new FormData();
  formData.append('canned_response[short_code]', data.short_code);
  formData.append('canned_response[content]', data.content);

  if (data.attachment) {
    formData.append('canned_response[attachment]', data.attachment);
  }

  if (data.attachments?.length) {
    data.attachments.forEach(attachment => {
      if (attachment) {
        formData.append('canned_response[attachments][]', attachment);
      }
    });
  }

  if (data.remove_attachment) {
    formData.append(
      'canned_response[remove_attachment]',
      data.remove_attachment
    );
  }

  if (data.remove_attachment_ids?.length) {
    data.remove_attachment_ids.forEach(attachmentId => {
      formData.append('canned_response[remove_attachment_ids][]', attachmentId);
    });
  }

  return formData;
};

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(data) {
    return axios.post(this.url, buildPayload(data));
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, buildPayload(data));
  }
}

export default new CannedResponse();
